<script setup lang="ts">
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import VButton from '@/Components/BaseComponents/VButton.vue'
import { ButtonType } from '@/BaseEnums'

const props = defineProps({
    submitButtonText: {
        type: String,
        required: true,
    },
    cancelButtonText: {
        type: String,
        required: true,
    },
    cancelButtonLink: {
        type: String,
        required: true,
    },
})

const page = usePage()
const appDetails = page.props.app_details

const buttonClasses = computed(() => {
    const customAuthColorsActive = appDetails.custom_auth_colors?.active
    const primaryCustomColor = appDetails.custom_auth_colors?.primary_color
    const secondaryCustomColor = appDetails.custom_auth_colors?.secondary_color
    let baseClasses = '!border-transparent w-full lg:w-auto '

    if (customAuthColorsActive && primaryCustomColor && secondaryCustomColor) {
        baseClasses += `!bg-[${primaryCustomColor}] hover:!bg-[${secondaryCustomColor}]`
    }

    return baseClasses
})
</script>

<template>
    <!-- temp div om custom numnum colors in te laden -->
    <div class="hidden !bg-[#5400cf] hover:!bg-[#6903ff]" />
    <div class="mt-4 lg:grid lg:grid-cols-3 gap-x-4">
        <div class="hidden lg:block" />
        <div class="lg:col-start-2 lg:col-span-2 lg:flex lg:justify-between lg:w-full">
            <v-button type="submit" :class="buttonClasses">
                {{ props.submitButtonText }}
            </v-button>
            <v-button :href="props.cancelButtonLink" variant="info">
                {{ props.cancelButtonText }}
            </v-button>
        </div>
    </div>
</template>

<style scoped lang="scss"></style>
